const ROLES = {
  ADMIN: 'backoffice_admin',
  USER: 'backoffice_user',
}

export default ROLES
